export default (error) => {
  if (error.response) {
    console.error('API - ERROR', error.response.status, error.response.config.url)
  } else if (error.request) {
    console.error('The request was made but no response was received')
  } else {
    console.error('Something happened in setting up the request that triggered an error')
  }

  return Promise.reject(error)
}
